import { combineReducers } from 'redux'

export const products = (state, action) => {
  switch(action.type) {
    case 'PRODUCT_ADDED':
      return [
        ...state,
        action.product
      ]
    case 'PRODUCT_UPDATED':
      return state.map(product => {
        if (product.id === action.product.id) {
          return Object.assign({}, product, action.product)
        }

        return product
      })
    case 'PRODUCT_REMOVED':
      return state.filter(product => product.id !== action.productId)
    case 'PRODUCT_BOUGHT':
      return state.map(product => {
        if (product.id === action.productId) {
          return Object.assign({}, product, {
            bought: !product.bought
          })
        }

        return product
      })
    default:
      return []
  }
}

export default combineReducers({
  products: products
})